import { render } from "./FlowExecutionBadges.vue?vue&type=template&id=6859a9a6"
import script from "./FlowExecutionBadges.vue?vue&type=script&lang=js"
export * from "./FlowExecutionBadges.vue?vue&type=script&lang=js"

import "./FlowExecutionBadges.vue?vue&type=style&index=0&id=6859a9a6&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
